import store from '../../../store/main';

function onRoleAccountCreated(event) {
  store.commit('roles/addAccountRole', { ...event.data });
}

export default onRoleAccountCreated;
